export default __webpack_public_path__ + "static/media/audio_27_piano.2492b5a9.mp3";